/**
 * 是否是server环境
 * 如果使用了jsdom之类mock window的操作，可以设置window.WorkbenchSSR为true来判断是server环境
 * @public
 */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const isServer = typeof window === 'undefined' || !!window.WorkbenchSSR;
const globalEnv = (() => {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line @typescript-eslint/no-implied-eval
    return Function('return this')();
})();

export { globalEnv, isServer };
//# sourceMappingURL=env.js.map
